var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_768)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_181_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4585 22.8821H3.1146C2.5415 22.8821 2.07642 22.4169 2.07642 21.8439V3.15615C2.07642 2.58306 2.54155 2.11797 3.1146 2.11797H12.4585C13.0326 2.11797 13.4967 1.65391 13.4967 1.07979C13.4967 0.505664 13.0326 0.0415039 12.4585 0.0415039H3.1146C1.39741 0.0415039 0 1.43896 0 3.15615V21.8438C0 23.561 1.39741 24.9584 3.1146 24.9584H12.4585C13.0326 24.9584 13.4967 24.4944 13.4967 23.9203C13.4967 23.3461 13.0326 22.8821 12.4585 22.8821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6906 11.7606L18.3783 5.53131C17.9713 5.12848 17.3131 5.13371 16.9103 5.54172C16.5075 5.94972 16.5116 6.6069 16.9207 7.00973L21.4317 11.4615H9.34385C8.76973 11.4615 8.30566 11.9256 8.30566 12.4997C8.30566 13.0738 8.76973 13.538 9.34385 13.538H21.4317L16.9207 17.9898C16.5117 18.3926 16.5085 19.0498 16.9103 19.4578C17.1138 19.6633 17.3816 19.7672 17.6495 19.7672C17.9132 19.7672 18.1769 19.6675 18.3783 19.4681L24.6906 13.2389C24.8879 13.0437 25 12.7779 25 12.4997C25 12.2215 24.8889 11.9568 24.6906 11.7606Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_181_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.36dddd2cf88576a9b50bb80f8abb6be2.svg";
export { ForwardRef as ReactComponent };